import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { DEFAULT_DISCLAIMER_ID } from "@Shared/js/constants";
export const GET_DISCLAIMERS_FILTERED = "GET_DISCLAIMERS_FILTERED";
export const IS_DEFAULT_DISCLAIMER_ENABLED = "IS_DEFAULT_DISCLAIMER_ENABLED";
export const GET_DEFAULT_DISCLAIMER = "GET_DEFAULT_DISCLAIMER";
const getters = {
  [GET_DISCLAIMERS_FILTERED]: state => consent => {
    var _context, _context2;
    return _filterInstanceProperty(_context = _mapInstanceProperty(_context2 = state.disclaimers.allIds).call(_context2, disclaimerId => state.disclaimers.byId[disclaimerId])).call(_context, disclaimer => !!disclaimer.consent === consent);
  },
  [IS_DEFAULT_DISCLAIMER_ENABLED]: state => {
    return state.defaultDisclaimerEnabled;
  },
  [GET_DEFAULT_DISCLAIMER]: state => {
    return state.disclaimers.byId[DEFAULT_DISCLAIMER_ID];
  }
};
export default getters;